<template lang="pug">
  .rowResult
    b-row
      b-col(cols="2") {{ label }}
      b-col(v-bind:class="{bestOfLine: isLinearBest}")
        div
          b Cases: {{ groupData.linear.number }}
          span.float-right
            b  Level {{ groupData.exponential.level }}
        div
          b M:
          |  {{ groupData.linear.m }}
        div
          b N:
          |  {{ groupData.linear.n }}
        div
          b R2:
          |  {{ groupData.linear.r_2 }}
        template(v-for="error in groupData.linear.error")
          div
            b Error:
            |  {{ error.text }}
        div(v-if="groupData.linear.error.length === 0").align-middle.pt-3.pb-3
          vue-mathjax(:formula="formulaLinear")
      b-col(v-bind:class="{bestOfLine: isSquareBest}")
        div
          b Cases: {{ groupData.square.number }}
          span.float-right
            b  Level {{ groupData.square.level }}
        div
          b M:
          |  {{ groupData.square.m }}
        div
          b N:
          |  {{ groupData.square.n }}
        div
          b R2:
          |  {{ groupData.square.r_2 }}
        template(v-for="error in groupData.square.error")
          div
            b Error:
            |  {{ error.text }}
        div(v-if="groupData.square.error.length === 0").align-middle.pt-3.pb-3
          vue-mathjax(:formula="formulaSquare")
      b-col(v-bind:class="{bestOfLine: isExponentialBest}")
        div
          b Cases: {{ groupData.exponential.number }}
          span.float-right
            b  Level {{ groupData.exponential.level }}
        div
          b M:
          |  {{ groupData.exponential.m }}
        div
          b N:
          |  {{ groupData.exponential.n }}
        div
          b R2:
          |  {{ groupData.exponential.r_2 }}
        template(v-for="error in groupData.exponential.error")
          div
            b Error:
            |  {{ error.text }}
        div(v-if="groupData.exponential.error.length === 0").align-middle.pt-3.pb-3
          vue-mathjax(:formula="formulaExpo")
      b-col() Result: {{ results }}

    b-row
      b-col --------------------------------------------

</template>

<script>
  import {VueMathjax} from 'vue-mathjax'

  export default {
    name: "rowResults",
    props: ['label','groupData', 'results'],
    data(){
      return {

      }
    },
    components: {
      'vue-mathjax': VueMathjax
    },
    computed:{
      isLinearBest() {return this.groupData.linear.r_2 > this.groupData.square.r_2 && this.groupData.linear.r_2 > this.groupData.exponential.r_2},
      isSquareBest() {return this.groupData.square.r_2 > this.groupData.linear.r_2 && this.groupData.square.r_2 > this.groupData.exponential.r_2},
      isExponentialBest() {return this.groupData.exponential.r_2 > this.groupData.linear.r_2 && this.groupData.linear.r_2 > this.groupData.square.r_2},
      formulaLinear(){ return `$$In-Out =  {n + mS}$$` },
      formulaSquare(){ return `$$In-Out =  {n + S^m}$$` },
      formulaExpo(){ return `$$In-Out =  {n \\cdot \\exp(mS)}$$` }
    }
  }

</script>

<style scoped>
  .bestOfLine{
    background-color: lightblue;
  }
</style>